import React, { useEffect } from 'react'
export default function Contact(props) {
    useEffect(() => {
        document.title = "Vabis' Literature Services - Literature Proofreading - Contact";
        window.scrollTo(0, 0);
    }, [])

    return (
        <div className="App">
            <div className="promotion">&#128218;&#128218;  CLAIM 10 PERCENT OFF NOW USING CODE: <b>10OFF</b> , USE IT ON PAYMENT PAGE  &#128218;&#128218;</div>
            <header>
                <h1>Contact</h1>
            </header>
            <div className="content-wrapper">
                <p>If you have question about my services, feel free to contact the email at the bottom.</p>
                <p>Please do not send any manuscripts/ thesis/ dissertation/ essay via email.</p>
                <p>My email: <a href='mailto:vabisliteratureservices@gmail.com'>vabisliteratureservices@gmail.com</a></p>
             </div>
        </div>
    )
}
